import { render, staticRenderFns } from "./AttachmentUrl.vue?vue&type=template&id=6a26dc4c&"
import script from "./AttachmentUrl.vue?vue&type=script&lang=js&"
export * from "./AttachmentUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports